<ion-app>

    <mea-menu></mea-menu>
    <ion-router-outlet id="main"></ion-router-outlet>

    <div *ngIf="!isProduction" class="dev-network-debug">
        <button
            (click)="toggleNetworkStatus()"
            [class.offline]="!isNetworkOnline"
        >
            {{ isNetworkOnline ? '🌐 Online' : '❌ Offline' }}
        </button>
    </div>

</ion-app>
